import React from 'react'
import { Link, Icon } from 'routes/components/Shared'
import LoginLink from 'routes/components/LoginLink'
import { PricingPlansCard } from './PricingPlansCard'
import { plansArray } from './plansArray'

export const PricingPlans = () => {
  return (
    <div className='pricing-plans'>
      <div className='flex-column pricing-plans__body'>
        <div className='pricing-plans__top'>
          <div className='flex-column pricing-plans__block'>
            <PricingPlansCard card={plansArray[0]} />
          </div>

          <div className='page__actions pricing-plans__actions'>
            <LoginLink
              className='page__button pricing-plans__button'
              type='primary'
            >
              Start Free Trial
            </LoginLink>
          </div>

          <Icon className='pricing-plans__arrow-icon' type='pricing-arrow' />
        </div>

        <div className='pricing-plans__bottom'>
          <div className='flex-column pricing-plans__block'>
            <PricingPlansCard card={plansArray[1]} />

            <div className='pricing-plans__plus-icon'>
              <Icon type='plus' />
            </div>
          </div>

          <div className='flex-column pricing-plans__block'>
            <PricingPlansCard card={plansArray[2]} />
          </div>

          <div className='page__actions pricing-plans__actions'>
            <Link
              className='page__button pricing-plans__button'
              type='primary'
              href='mailto:hello@integration.app'
            >
              Get a Quote
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
